import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'https://junichirokoyama.com/admin/wp-json/wp/v2';
// axios.defaults.baseURL = 'http://localhost:8888/wp-json/wp/v2';
// axios.defaults.headers.get['Accept'] = 'application/jso';
// axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';


const store = new Vuex.Store({
  state: {
    tags: null,
    projects: null,
    sortPrj: "Featured",
    experiences: null
  },
  actions: {
    getTags: function(context) {
      axios.get('/tags/?per_page=99', { crossdomain: true })
      .then((response) => {
				context.commit('storeTags', response.data)
			})
    },
    getProjects: function(context) {
      return new Promise((resolve, reject) => { 
        if(context.state.projects) {
          resolve()
        }
        else {
          axios.get('/projects', { crossdomain: true })
          .then((response) => {
            context.commit('storeProjects', response.data)
            resolve()
          }).catch((error) => {
            reject(error);
          });
        }
      })
    },
    getBlogs: function(context) {
      return new Promise((resolve, reject) => { 
        if(context.state.blogs) {
          resolve()
        }
        else {
          axios.get('/posts', { crossdomain: true })
          .then((response) => {
            context.commit('storeBlogs', response.data)
            resolve()
          }).catch((error) => {
            reject(error);
          });
        }
      })
    },
    getExperiences: function(context) {
      return new Promise((resolve, reject) => { 
        if(context.state.experiences) {
          resolve()
        }
        else {
          axios.get('/experiences', { crossdomain: true })
          .then((response) => {
            context.commit('storeExperiences', response.data)
            resolve()
          }).catch((error) => {
            reject(error);
          });
        }
      })
    }
  },
  mutations: {
    storeTags(state, response) {
      state.tags = response 
    },
    storeProjects(state, response) {
      state.projects = response 
    },
    storeBlogs(state, response) {
      state.blogs = response 
    },
    storeExperiences(state, response) {
      state.experiences = response 
    }
  }
})
export default store